<ol class="inspections">
  <li>
    <span class="inspection-item">תוצאות הבדיקה:</span>
    <ol class="notes">
      <li *ngFor="let item of mainItems">
        <strong>{{ item.label }}: {{ item.value }}</strong>
        <ol class="notes">
          <li *ngFor="let note of item.notes">
            <strong>{{ note.notes }}</strong>
          </li>
        </ol>
      </li>
      <li>
        <span class="case" style="display: block"
          >להלן רשימת הרכיבים במערכת:</span
        >
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 25%">
                <strong>סוג</strong>
              </th>
              <th style="width: 20%">
                <strong>דגם</strong>
              </th>
              <th style="width: 20%">
                <strong>תוצרת</strong>
              </th>
              <th style="width: 35%">
                <strong>הערות</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let component of inspection.fireAlarmSystemDesign
                  ?.fireAlarmSystemComponents?.components
              "
            >
              <td>
                <span>{{ component?.type }}</span>
              </td>
              <td>
                <span>{{ component?.model }}</span>
              </td>
              <td>
                <span>{{ component?.manufacture }}</span>
              </td>
              <td>
                <span>{{ component?.notes || '--' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
    </ol>
  </li>

  <br />
  <li *ngFor="let dialer of dialers | filterBy: ['isApplicable']:true">
    <span class="inspection-item">{{ dialer.title }}</span>
    <ol>
      <li>
        <strong style="display: table-cell"
          >מספר טלפון של החייגן: {{ dialer.dialNumber }}</strong
        >
      </li>
      <li *ngFor="let contact of dialer.contacts; let i = index">
        <strong style="display: table-cell">
          <span
            >דיווח {{ i + 1 }} - מספר הטלפון אליו מחייג החייגן:
            {{ contact.phone || '--' }}</span
          >
          <span style="margin-right: 30px"
            >שם מקבל ההודעה: {{ contact.name || '--' }}</span
          >
        </strong>
      </li>
      <li>
        <strong style="display: table-cell"
          >שעת בדיקת החייגן: {{ dialer.checkTime }}</strong
        >
      </li>
      <li *ngFor="let note of dialer.getNotes()">
        <strong style="display: table-cell">{{ note.notes }}</strong>
      </li>
    </ol>
  </li>

  <br />
  <li>
    <span class="inspection-item">הערות נוספות על ידי המעבדה:</span>
    <ol class="notes">
      <li *ngFor="let item of extraNotes">
        <strong>{{ item.title }}</strong>

        <ol class="notes" *ngIf="item.notes.length > 0">
          <li *ngFor="let note of item.notes">
            <strong>{{ note }}</strong>
          </li>
        </ol>

        <ol class="notes" *ngIf="item.multiNotes.length > 0">
          <li
            *ngFor="
              let note of item?.multiNotes | filterBy: ['addNotesToReport']:true
            "
          >
            <strong>{{ note.notes }}</strong>
            <ol>
              <li
                *ngFor="
                  let subNote of note.subNotes
                    | filterBy: ['addNotesToReport']:true
                "
              >
                <strong style="display: table-cell">{{ subNote.notes }}</strong>
              </li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>
  </li>
  <br />
  <li>
    <span class="inspection-item">כללי:</span>
    <ol>
      <li
        *ngFor="
          let item of inspection?.summaryNotes
            | filterBy: ['addNotesToReport']:true
        "
      >
        <strong class="underline" style="display: table-cell">{{
          item.notes
        }}</strong>
        <ol style="margin-right: 15px">
          <li
            *ngFor="
              let subNote of item.subNotes | filterBy: ['addNotesToReport']:true
            "
          >
            <strong class="underline" style="display: table-cell">{{
              subNote.notes
            }}</strong>
          </li>
        </ol>
      </li>
    </ol>
  </li>
</ol>
